import Vue from 'vue'
import VueRouter from 'vue-router'
import Directory from '@/views/Directory.vue'
import Index from '@/views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Directory',
    component: Directory
  },
  {
    path: '/:slug',
    name: 'Index',
    component: Index
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
